<template>
    <v-card class="ma-1 mb-2">
        <v-row align="center" no-gutters class="pa-2">
            <v-col class="d-flex align-center">
                <Icon :icon="vehicle.icon" :height="20" :width="20" :color="vehicle?.boat_mark_color">
                </Icon>
                <div class="d-flex flex-column  ml-2">
                    <span class="font-weight-bold text-subtitle-1 text-left">
                        {{ vehicle.name }}
                    </span>
                </div>
            </v-col>

            <v-col cols="auto" class="d-flex align-center">
                <v-btn icon="mdi-magnify" color="primary" @click="emit('search', vehicle)" variant="plain"></v-btn>
            </v-col>
        </v-row>
    </v-card>
</template>

<script setup>
import { ref } from 'vue';
import Icon from '../icons/Icon.vue';

const { vehicle } = defineProps(['vehicle']);
const emit = defineEmits(['search']);

</script>
